const ERROR_CODES = {
    NO_HMRC_AUTHORIZATION: 13,
    NO_SUBMISSION_FOUND: 15,
    DISABLED_TAX_YEAR: 25
};

export default ERROR_CODES;
